<template>
    <div class="file-viewer-av tw:flex tw:flex-col tw:items-center tw:justify-center tw:h-full tw:min-h-0 tw:gap-4">
        <!-- Previews arbitrary uploaded files, which carry no caption track to attach. -->
        <!-- eslint-disable vue-a11y/media-has-caption -->
        <video
            v-if="kind === 'video'"
            :src="src"
            class="tw:max-w-full tw:max-h-full"
            controls
            controlsList="nodownload"
            @loadeddata="$emit('ready')"
            @error="$emit('error')"
        >
            Your browser does not support video playback.
        </video>
        <audio
            v-else
            :src="src"
            class="tw:w-full"
            controls
            controlsList="nodownload"
            @loadeddata="$emit('ready')"
            @error="$emit('error')"
        >
            Your browser does not support audio playback.
        </audio>
        <!-- eslint-enable vue-a11y/media-has-caption -->
    </div>
</template>

<script setup>
defineProps({
    src: {
        type: String,
        required: true,
    },
    kind: {
        type: String,
        required: true,
        validator: value => ['audio', 'video'].includes(value),
    },
});

defineEmits(['ready', 'error']);
</script>
